import { Tabs } from '@cian/ui-kit/tabs';
import { Body2, UIHeading2, UIHeading3, UIHeading5 } from '@cian/ui-kit/typography';
import type { Ref } from 'react';

import { PhoneButton } from 'shared/components/common/PhoneButton';
import type { IBuildingRepresentative } from 'shared/types/buildingCard';
import type { IFloatingHeaderNavItem } from 'shared/utils/floatingHeader';

import style from './style.css';

export interface IFloatingHeaderProps {
  ref?: Ref<HTMLDivElement>;
  isVisible: boolean;
  title: string;
  navItems: IFloatingHeaderNavItem[];
  activeIndex: number;
  onNavClick(index: number): void;
  area: string | null;
  rate: string | null;
  representative: IBuildingRepresentative | null;
}

/**
 * Плавающая шапка — `floating_header.html` монолита. Скрытая сдвинута вверх и невидима (не `display: none`),
 * чтобы измерялась её высота; появляется и прячется с анимацией, как на проде
 */
export const FloatingHeader = ({
  ref,
  isVisible,
  title,
  navItems,
  activeIndex,
  onNavClick,
  area,
  rate,
  representative,
}: IFloatingHeaderProps) => (
  <div
    ref={ref}
    className={isVisible ? style['container'] : `${style['container']} ${style['hidden']}`}
    data-name="FloatingHeader"
  >
    <div className={style['content']}>
      <div className={style['left']}>
        <div className={style['main']}>
          <UIHeading2 as="div">{title}</UIHeading2>
          <nav>
            <Tabs
              items={navItems.map(({ targetId, label, counter }) => ({
                text: label,
                counter,
                dataTestId: `FloatingHeaderNav-${targetId}`,
              }))}
              activeTabIndex={activeIndex}
              rightItem="counter"
              counterMaxLength={3}
              bottomDivider={false}
              onTabClick={onNavClick}
            />
          </nav>
        </div>
        {(area || rate) && (
          <div className={style['summary']}>
            {area && <UIHeading3 as="div">{area}</UIHeading3>}
            {rate && <Body2>{rate}</Body2>}
          </div>
        )}
      </div>
      {representative && (
        <div className={style['right']} data-name="FloatingHeaderRepresentative">
          <UIHeading5 as="div">{representative.name}</UIHeading5>
          <PhoneButton phones={representative.phones} isCompact />
        </div>
      )}
    </div>
  </div>
);
